exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-cards[data-v-35678e0c]{display:flex;flex-wrap:wrap;gap:1rem;margin:1rem 0}.card[data-v-35678e0c]{border-top:5px solid var(--tan);background-color:#fffaed;flex-basis:300px}", ""]);

// exports
